module.exports = __webpack_public_path__ + "images/2.1789440611829.jpg";